import { render, staticRenderFns } from "./QueenList.vue?vue&type=template&id=2e9a58c8&scoped=true&"
import script from "./QueenList.vue?vue&type=script&lang=js&"
export * from "./QueenList.vue?vue&type=script&lang=js&"
import style0 from "./QueenList.vue?vue&type=style&index=0&id=2e9a58c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9a58c8",
  null
  
)

export default component.exports